var map = {
	"./arrow-up.svg": "290b",
	"./bars.svg": "2aec",
	"./box-alt.svg": "de48",
	"./camera.svg": "04e1",
	"./check.svg": "95c9",
	"./close.svg": "496d",
	"./download.svg": "3599",
	"./envelope-open.svg": "2904",
	"./envelope.svg": "dc3a",
	"./event/approved-double.svg": "8bc5",
	"./event/approved.svg": "ab5d",
	"./event/article-approved-rework-2.svg": "5fc0",
	"./event/article-approved-rework.svg": "3886",
	"./event/article-check.svg": "9df7",
	"./event/article-review-2.svg": "9b5f",
	"./event/article-review.svg": "4b7f",
	"./event/article-rework.svg": "5c09",
	"./event/cancelled.svg": "b614",
	"./event/question.svg": "327e",
	"./event/upload.svg": "b97d",
	"./external-link.svg": "1873",
	"./inbox-in.svg": "9d3d",
	"./inbox-out.svg": "b94f",
	"./loading.svg": "5491",
	"./pencil.svg": "8f19",
	"./plus.svg": "dca5",
	"./redo.svg": "8250",
	"./search.svg": "6194",
	"./table.svg": "e3df",
	"./telegram.svg": "1339",
	"./trash.svg": "ce8e",
	"./whatsapp.svg": "8ad1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "efff";